'use strict';

import $ from 'jquery';
import debounce from 'lodash/debounce';

export default class SiteFooter {
	constructor() {
		this.name = 'site-footer';

		let $siteFooter = $('.site-footer'),
			$backTopBtn = $('.btn-back-top', $siteFooter);

		const $header = $('header'),
		$headerHeight = $header.outerHeight(),
		$headerOffsetTop = $header.offset().top;

		const totalHeaderHeight = $headerOffsetTop + $headerHeight;

		$(window).on('scroll', debounce(function(){

			const $windowScrollTop = $(window).scrollTop();

			if($windowScrollTop > totalHeaderHeight) {
				$backTopBtn.addClass('show');
			} else {
				$backTopBtn.removeClass('show');
			}
		}));

		$backTopBtn.on('click', (e) => {
			e.preventDefault();

			$('html, body').stop().animate({
				scrollTop: 0
			}, 500, 'linear');
		});
	}
}
